import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';
import { GENERAL_SETTINGS_LINK } from '../../../../../shared/navigation/constants';

@Component({
  selector: 'yi-magento1-install-yotpo-widget',
  template: require('./magento1_install_yotpo_widget.component.html'),
  styles: [require('./magento1_install_yotpo_widget.component.scss')]

})

export class Magento1InstallYotpoWidgetComponent extends AccordionContentComponent {

  private generalSettingsLink = GENERAL_SETTINGS_LINK;

  linkToCreds() {
    this.redirectService.redirectTo(this.generalSettingsLink, true);
  }
}
